import { CircularProgress } from '@mui/material';
import useFetch from "./useFetch";
import hbricon from "./otherImg/hrmwlitelogo.png";
import DevotionListContent from './DevotionListcontent';

const DailyDevotion = () => {
  const {data: books ,ispending,erroralert} = useFetch(`${process.env.REACT_APP_BOOKS_SERVER_URL}/dailydevotioneng`);
  // const {data: books ,ispending,erroralert} = useFetch(`http://localhost:3500/dailydevotioneng`);

 
    return (  
        <div className="homeenglishbooks">

              {erroralert && 
              <div style={{position:"fixed",top:"30%",left:"40%"}}>
                <h4>{erroralert}</h4>               
              </div>}
        
            {ispending && <div style={{position:"fixed",top:"30%",left:"40%"}}> 
            <CircularProgress color="secondary" /> <br/>
            Fetching books...
            </div>}  

          
            <div className="search-field">
                <h4>Every Word of God for daily living</h4>

                  <div className="pagetoplogo flex-row2">
                        <h3>HbrSoftTeam</h3>
                        <img src={hbricon} alt=""/>
                  </div>
            </div>

            <div className="search-field-phone">
            <h4>Every Word of God for daily living</h4>           
                  <div className="pagetoplogo flex-row2">
                       <img src={hbricon} alt=""/>
                  </div>
            </div>
            
            <div className="fetchedBooks">
                    {books && books.map((books) => (
                        <DevotionListContent
                        key={books.id} 
                        bookid = {books._id}
                        title={books.title}
                        image={books.image}
                        />
                    ))
                    }
            </div>
      </div>
    );
}
export default DailyDevotion;